import React from 'react';
import { ui } from '../../styles/shared';

// Visas i flikarna när myUplink är avstängt. Länken hoppar till statusfliken.
const DisabledNotice: React.FC<{ onGoToStatus: () => void }> = ({ onGoToStatus }) => (
    <div style={{ ...ui.card, textAlign: 'center', color: '#888' }}>
        myUplink är avstängt. Slå på det under <button onClick={onGoToStatus} style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', fontWeight: 'bold' }}>Status och inställningar</button>.
    </div>
);

export default DisabledNotice;
